import styles from './ProductView.module.scss';
import classNames from 'classnames';
import { ProductDetails, ProductDetailsProps } from 'ui/components';
export interface ProductViewProps {
	className?: string;
	imageSizes?: string;
	productDetails: ProductDetailsProps;
	addToShoppingCart: (cartProduct: Models.CartProduct) => void;
}

export const ProductView: React.FC<ProductViewProps> = ({
	className,
	// imageSizes,
	productDetails,
}) => (
	<div className={classNames(styles.ProductView, className)}>
		<div className={styles.ProductView_TopWrapper}>
			<ProductDetails {...productDetails} className={styles.ProductView_details} />
		</div>
	</div>
);
